import { BerthCallInfo } from '../types/ViewModel/BerthCallInfo';

export default () => {
    const createBerthCallInfoListBM = (berthCallInfoList: BerthCallInfo[]): any[] => {
        return berthCallInfoList.map((o) => {
            return createBerthCallInfoItemBM(o.berthCallId, o.name);
        });
    };

    const createBerthCallInfoItemBM = (berthCallId: number, name: string): any => {
        return {
            berthCallId: berthCallId,
            name: name,
        };
    };

    const createBerthCallInfoItem = (berthCallId: number, name: string): BerthCallInfo => {
        return new BerthCallInfo(berthCallId, name);
    };

    return {
        createBerthCallInfoListBM,
        createBerthCallInfoItemBM,
        createBerthCallInfoItem,
    };
};
